import { LOCALE_ID, ModuleWithProviders, NgModule, NgModuleFactoryLoader, SystemJsNgModuleLoader } from "@angular/core";
import { bpmRuntimeExecutionService, BpmRuntimeExecutionService } from "@edp-bpm/universal-runtime-api";
import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { FormsModule } from "@angular/forms";
import { MessagerModule } from "@farris/ui-messager";
import { LoadingModule } from "@farris/ui-loading";
import { NotifyModule } from "@farris/ui-notify";
import { FarrisSectionModule } from "@farris/ui-section";
import { DatagridModule } from "@farris/ui-datagrid";
import { FarrisDialogModule } from "@farris/ui-dialog";
import { BpmRuntimeDevkitService } from "./bpm-runtime-devkit.service";
import { CacheService, HttpService, SessionService } from "@ecp-caf/caf-common";
import { AppService, FrameworkService, FrmEventBus, FuncsService, LoadingService } from "@gsp-sys/rtf-common";
import { BPM_RUNTIME_DEVKIT_LANG_RESOURCES_TOKEN, LocalePipe } from "./pipe/locale.pipe";
import { BPM_RUNTIME_DEVKIT_LANG_RESOURCES } from "./i18n/lang.resource";

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        FormsModule,
        MessagerModule.forRoot(),
        LoadingModule.forRoot(),
        NotifyModule,
        FarrisSectionModule,
        DatagridModule.forRoot(),
        FarrisDialogModule,
    ],
    providers: [
        { provide: LOCALE_ID, useValue: localStorage.getItem('languageCode') || 'zh-CHS' },
        { provide: BPM_RUNTIME_DEVKIT_LANG_RESOURCES_TOKEN, useValue: BPM_RUNTIME_DEVKIT_LANG_RESOURCES },
        { provide: NgModuleFactoryLoader, useClass: SystemJsNgModuleLoader },
        CacheService,
        SessionService,
        HttpService,
        FrmEventBus,
        FuncsService,
        LoadingService,
        AppService,
        FrameworkService,
        { provide: BpmRuntimeExecutionService, useValue: bpmRuntimeExecutionService },
        BpmRuntimeDevkitService,
    ],
    declarations: [
        LocalePipe,
    ],
    entryComponents: [
    ],
    bootstrap: [
    ],
    exports: [
        LocalePipe,
    ],
})
export class BpmRuntimeDevkitModule {
    public static forRoot(opts?: any): ModuleWithProviders {
        return {
            ngModule: BpmRuntimeDevkitModule,
            providers: []
        }
    }
}